import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

import {
    DEFAULT_ENTERPRISE_DISPLAY_NAME,
    getConnectedEnterpriseNameFromLocalStorage,
    getConnectedEnterpriseNameFromUser,
    resolveEnterpriseDisplayName,
} from './enterprise-context';

@Injectable({ providedIn: 'root' })
export class EnterpriseBrandingService {
    private readonly _name$ = new BehaviorSubject<string>(
        getConnectedEnterpriseNameFromLocalStorage() || DEFAULT_ENTERPRISE_DISPLAY_NAME
    );

    readonly name$ = this._name$.asObservable();

    constructor(private _title: Title) {}

    getName(): string {
        return this._name$.getValue();
    }

    setName(name?: string | null): void {
        const resolved = resolveEnterpriseDisplayName(name);
        this._name$.next(resolved);
        this._title.setTitle(resolved);
    }

    syncFromUser(user: unknown): void {
        this.setName(getConnectedEnterpriseNameFromUser(user));
    }

    syncFromLocalStorage(): void {
        this.setName(getConnectedEnterpriseNameFromLocalStorage());
    }
}
